// extracted by mini-css-extract-plugin
export default {"sharedIcon":"Item_sharedIcon__ujnbV"};